export function validateAndConvertFraction(value: string): string | boolean {

    let fractionParts: string[];

    if (value.includes('/')) {
        fractionParts = value.split('/');
    } else if (value?.toLowerCase().includes('de')) {
        fractionParts = value?.toLowerCase().split('de');
    } else if(value?.toLowerCase().includes('d')){
        fractionParts = value?.toLowerCase().split('d');
    } else {
        return false; // Return null if neither delimiter is found
    }

    if (fractionParts.length === 2) {
        const numerator = parseFloat(fractionParts[0].trim());
        const denominator = parseFloat(fractionParts[1].trim());

        if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
            return `${numerator} de ${denominator}`;
        }
    }

    return false; 
}